import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { RecentFlowScope } from "./recent-scopes/service.ts";
import type { RecordingListInput, RecordingListView, RecordingPlayerInput, RecordingPlayerView, RecordingPlayerCommand, RecordingSettlement } from "./model.ts";
export interface RecordingListSession {
    readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<RecordingListView>>;
    readonly read: Effect.Effect<RecordingListView>;
    readonly receive: (input: RecordingListInput) => Effect.Effect<void>;
    readonly refresh: (inputKey: string) => Effect.Effect<void>;
}
export interface RecordingPlayerSession {
    readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<RecordingPlayerView>>;
    readonly read: Effect.Effect<RecordingPlayerView>;
    readonly receive: (input: RecordingPlayerInput, onDeleted: Effect.Effect<void>) => Effect.Effect<void>;
    readonly dispatch: (key: string, command: RecordingPlayerCommand) => Effect.Effect<void>;
    readonly fullscreen: (target: HTMLElement | null) => Effect.Effect<void>;
    readonly settlements: Effect.Effect<{
        readonly total: number;
        readonly recent: readonly RecordingSettlement[];
    }>;
}
export class RecordingSessions extends Context.Service<RecordingSessions, {
    readonly list: Effect.Effect<RecordingListSession, never, Scope.Scope>;
    readonly player: Effect.Effect<RecordingPlayerSession, never, Scope.Scope>;
}>()("workerstation/frontend/RecordingSessions") {
}
export class RecordingBrowserIo extends Context.Service<RecordingBrowserIo, {
    readonly fullscreen: (target: HTMLElement | null) => Effect.Effect<void, ResourceFailure>;
    readonly confirmDelete: Effect.Effect<boolean, ResourceFailure>;
    readonly copy: (text: string) => Effect.Effect<void, ResourceFailure>;
    readonly nativeHref: (url: string) => Effect.Effect<string, ResourceFailure>;
    readonly preload: (url: string) => Effect.Effect<void, ResourceFailure, Scope.Scope>;
    readonly recentScopes: (workspaceId: string) => Effect.Effect<readonly RecentFlowScope[]>;
}>()("workerstation/frontend/RecordingBrowserIo") {
}
